import { render, staticRenderFns } from "./SettingsDropbox.vue?vue&type=template&id=a13288f4"
import script from "./SettingsDropbox.vue?vue&type=script&lang=js"
export * from "./SettingsDropbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports